var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, eventListener, object, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableCloseEvent, CloseEvent, OpenEvent, SwapEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, createAbort, isDefined, isEnumValid, isFunction, isMobile } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as RotateDeviceIcon } from '../../../resources/assets/components/DLS_RotateDevice.svg';
import { MediaContainerMode } from '../media-container/media-container-constants.js';
import { Modal } from '../modal/modal.js';
import MediaContainerAPI from './media-container-api.js';
import MediaContainerItem from './media-container-item/media-container-item.js';
import './media-container.css';
let MediaContainer = class MediaContainer extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            firstContainerItemImg: { src: '' },
            mode: MediaContainerMode.DEFAULT,
            open: false,
            secondContainerItemImg: { src: '' },
            showControls: true,
        };
        this.getMediaContainerContentClassName = () => {
            const { className } = this.props;
            const { mode } = this.state;
            return classNames({
                'c-media-container-modal__content': true,
                [`c-media-container-modal__content--${mode}`]: isEnumValid(MediaContainerMode, mode),
                [`${className}`]: Boolean(className),
            });
        };
        this.toggleControls = () => {
            if (!isMobile()) {
                return;
            }
            this.setState((prevState) => ({ showControls: !prevState.showControls }));
        };
        this.renderRotateIcon = () => {
            return (React.createElement("div", { className: "c-media-container__rotate-icon" },
                React.createElement(RotateDeviceIcon, null)));
        };
        this.onOpen = () => {
            const { onOpen } = this.props;
            if (isFunction(onOpen)) {
                onOpen(new OpenEvent());
            }
        };
        this.onClose = () => {
            const { onBeforeClose, onClose } = this.props;
            const abort = createAbort();
            if (isFunction(onBeforeClose)) {
                onBeforeClose(new AbortableCloseEvent({ abort }));
            }
            void abort.promise.then((aborted) => {
                if (aborted) {
                    return;
                }
                this.setState({ open: false }, () => {
                    if (isFunction(onClose)) {
                        onClose(new CloseEvent());
                    }
                });
            });
        };
        this.onSwap = () => {
            const { onSwap } = this.props;
            if (isFunction(onSwap)) {
                onSwap(new SwapEvent());
            }
        };
        this.swapImage = (isFirstContainerImg, step) => {
            const { data } = this.props;
            const { firstContainerItemImg, secondContainerItemImg } = this.state;
            const currentImg = isFirstContainerImg ? firstContainerItemImg : secondContainerItemImg;
            if (!currentImg) {
                return;
            }
            const currentImageIndex = data.indexOf(currentImg);
            const lessThanFirstIndex = currentImageIndex + step < 0;
            const greaterThanLastIndex = currentImageIndex + step > data.length - 1;
            const newImage = data[currentImageIndex + step];
            if (currentImageIndex <= -1 || lessThanFirstIndex || greaterThanLastIndex) {
                return;
            }
            if (isFirstContainerImg) {
                return this.setState({ firstContainerItemImg: newImage }, this.onSwap);
            }
            this.setState({ secondContainerItemImg: newImage }, this.onSwap);
        };
        this.getModalTitle = () => {
            const { title } = this.props;
            const { firstContainerItemImg, mode, secondContainerItemImg } = this.state;
            if (mode === MediaContainerMode.COMPARISON && firstContainerItemImg.name && secondContainerItemImg.name) {
                return `${firstContainerItemImg.name} | ${secondContainerItemImg.name}`;
            }
            if (mode === MediaContainerMode.DEFAULT && firstContainerItemImg.name) {
                return firstContainerItemImg.name;
            }
            return title;
        };
    }
    componentDidMount() {
        const { data, initialOpen } = this.props;
        if (isDefined(initialOpen)) {
            this.setState({ open: Boolean(initialOpen) }, () => initialOpen && this.onOpen());
        }
        if (data.length) {
            this.setState({ firstContainerItemImg: data[0], secondContainerItemImg: data[0] });
        }
    }
    componentDidUpdate(prevProps) {
        const { data } = this.props;
        if (!prevProps.data.length && data.length) {
            this.setState({ firstContainerItemImg: data[0], secondContainerItemImg: data[0] });
        }
    }
    renderContainerItem(isFirstContainerImg) {
        const { data, deleteOptionEnabled, downloadOptionEnabled, onDelete, onDownload, onPrint, onResetZoom, onZoomIn, onZoomOut, printOptionEnabled } = this.props;
        const { firstContainerItemImg, showControls, secondContainerItemImg } = this.state;
        return (React.createElement(MediaContainerItem, { currentImage: isFirstContainerImg ? firstContainerItemImg : secondContainerItemImg, data: data, deleteOptionEnabled: deleteOptionEnabled, downloadOptionEnabled: downloadOptionEnabled, onDelete: onDelete, onDownload: onDownload, onImageAreaClick: this.toggleControls, onPrint: onPrint, onResetZoom: onResetZoom, onZoomIn: onZoomIn, onZoomOut: onZoomOut, printOptionEnabled: printOptionEnabled, showControls: showControls, swapImage: (step) => this.swapImage(isFirstContainerImg, step) }));
    }
    render() {
        const { mode, open, showControls } = this.state;
        if (!open) {
            return null;
        }
        return (React.createElement(Modal, { className: "c-media-container-modal", closeable: true, noPadding: true, onClose: this.onClose, title: this.getModalTitle() },
            React.createElement("div", { className: this.getMediaContainerContentClassName() },
                this.renderContainerItem(true),
                mode === MediaContainerMode.COMPARISON && this.renderContainerItem(false),
                (isMobile() && showControls) && this.renderRotateIcon())));
    }
};
MediaContainer.propTypes = {
    className: string,
    data: arrayOf(object).notEnumerable(),
    deleteOptionEnabled: bool,
    downloadOptionEnabled: bool,
    initialOpen: bool,
    onBeforeClose: eventListener,
    onBeforeDelete: eventListener,
    onClose: eventListener,
    onDelete: eventListener,
    onDownload: eventListener,
    onOpen: eventListener,
    onPrint: eventListener,
    onResetZoom: eventListener,
    onSwap: eventListener,
    onZoomIn: eventListener,
    onZoomOut: eventListener,
    printOptionEnabled: bool,
    title: string,
};
MediaContainer.defaultProps = {
    data: [],
    deleteOptionEnabled: true,
    downloadOptionEnabled: true,
    printOptionEnabled: true,
    title: '',
};
MediaContainer = __decorate([
    AwesomeComponent({ api: MediaContainerAPI, type: ComponentType.DATA_DISPLAY })
], MediaContainer);
export default MediaContainer;
//# sourceMappingURL=media-container.js.map